import { getText } from '@/utils/text/text';

/**
 * Formats time in minutes to a readable string with pluralization.
 * @param time - Time in minutes.
 * @returns Formatted time string.
 */
export const timeToString = (time: number): string => {
    return `${time} ${getText({
        text: 'components.dateAndTimeUnits.minutes',
        n: time
    })}`;
};
